<template>
  <v-row>
    <v-col cols="12" offset-lg="1" lg="10">
      <v-breadcrumbs :items="breadcrumbs" divider=">" class="pl-1 pb-3" />
      <v-card class="mb-3">
        <v-card-title class="theme">
          <v-icon class="white--text">rule</v-icon>
          <span class="headline ml-2 white--text">Workflows</span>
        </v-card-title>
        <v-divider />
        <v-card-text>
          <v-col cols="12">
            <v-card
              v-for="(item, i) in workflows"
              :key="i"
              class="white--text mt-2 action"
            >
              <v-card-title primary-title>
                <v-row>
                  <v-col cols="12" md="2" class="hidden-sm-and-down">
                    <v-row class="fill-height" align="center" justify="center">
                      <v-icon x-large color="white">supervisor_account</v-icon>
                    </v-row>
                  </v-col>
                  <v-col cols="12" sm="10" md="8">
                    <div class="headline">
                      {{ item.name }} ({{ item.tasks ? item.tasks.length : 0 }}
                      tasks)
                    </div>
                    <div>{{ item.description }}</div>
                  </v-col>
                  <v-col cols="12" sm="2" class="mt-3 text-right pr-5">
                    <v-btn
                      @click="showWorkflow(item.id)"
                      depressed
                      class="theme-text rounded-sm"
                    >
                      {{ !item.tasks ? "Add Tasks" : "Edit" }}
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-title>
            </v-card>
            <div class="text-center mt-8">
              <v-btn
                fab
                small
                class="theme white--text"
                depressed
                @click="previous"
                :disabled="pagination.page <= 0"
              >
                <v-icon small>navigate_before</v-icon>
              </v-btn>
              <span class="px-6">{{ pagination.page + 1 }}</span>
              <v-btn
                fab
                small
                depressed
                class="white--text theme"
                @click="next"
                :disabled="pagination.disableNext"
              >
                <v-icon small>navigate_next</v-icon>
              </v-btn>
            </div>
          </v-col>
        </v-card-text>
      </v-card>

      <v-row dense>
        <v-col cols="12" sm="6" md="4" class="mt-2 pr-1">
          <v-card>
            <v-responsive height="150px" class="theme">
              <v-row class="fill-height" align="center" justify="center">
                <v-icon style="font-size: 80px" color="white"
                  >supervisor_account</v-icon
                >
              </v-row>
            </v-responsive>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-4 text-capitalize">On-boarding</h3>
                <div class="subheading grey--text text--darken-1 mt-3">
                  Each workflow consists of several tasks that will initiate
                  when employee onboards. For eg. For new employees trigger a
                  task to provide system access!
                </div>
              </div>
              <v-btn
                depressed
                @click="createWF('OnBoarding')"
                color="action white--text rounded-sm ml-0 mt-3"
                >Add Workflow
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" class="mt-2 px-1">
          <v-card>
            <v-responsive height="150px" class="theme">
              <v-row class="fill-height" align="center" justify="center">
                <v-icon style="font-size: 80px" color="white"
                  >supervisor_account
                </v-icon>
              </v-row>
            </v-responsive>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-4 text-capitalize">Off-boarding</h3>
                <div class="subheading grey--text text--darken-1 mt-3">
                  Before your employee leaves, you want to complete certain
                  tasks like returning inventory handover, revoke system access.
                  You can add those tasks here!
                </div>
              </div>
              <v-btn
                text
                @click="createWF('OffBoarding')"
                class="action white--text ml-0 mt-3 rounded-sm"
                >Add Workflow
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>

        <v-col cols="12" sm="6" md="4" class="mt-2 pl-1">
          <v-card>
            <v-responsive class="theme" height="150px">
              <v-row class="fill-height" align="center" justify="center">
                <v-icon color="white" style="font-size: 80px">shuffle</v-icon>
              </v-row>
            </v-responsive>
            <v-card-title primary-title>
              <div>
                <h3 class="headline mb-4 text-capitalize">Custom Workflow</h3>
                <div class="subheading grey--text text--darken-1 mt-3 mb-4">
                  You can create your custom workflows and trigger them manually
                  and do something about it.
                  <br />
                </div>
              </div>
              <v-btn
                text
                @click="createWF('Custom')"
                class="action white--text ml-0 rounded-sm mt-14"
                style="margin-top: 40px"
                >Add Workflow
              </v-btn>
            </v-card-title>
          </v-card>
        </v-col>
      </v-row>
    </v-col>
    <v-snackbar v-model="snackbar" :bottom="true" :right="true">
      {{ snackbarMessage }}
      <v-btn color="pink" text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-row>
</template>

<script>
import { mapGetters } from "vuex";

import { Actions } from "@/views/actions";
import { Breadcrumbs } from "@/views/breadcrumbs";
import { Component } from "@/views/component";
import { Constants } from "@/views/constants";

export default {
  name: Component.Protected.Company.Workflow.List,
  data: () => ({
    breadcrumbs: Breadcrumbs.Workflows.List,
    pagination: {
      disableNext: true,
      page: 0,
    },
    search: {
      name: "",
      type: "",
      limit: 10,
      offset: 0,
    },
  }),
  computed: {
    ...mapGetters(["userInfo", "workflows"]),
  },
  methods: {
    next() {
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else if (this.workflows.length < this.search.limit) {
        this.pagination.disableNext = false;
        this.pagination.page++;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getWorkflows();
      }
    },
    previous() {
      this.pagination.page--;
      if (this.pagination.page < 0) {
        this.pagination.page = 0;
        this.search.offset = 0;
      } else {
        this.pagination.disableNext = false;
        this.search.offset = this.search.limit * this.pagination.page;
        this.getWorkflows();
      }
    },
    setup() {
      if (this.userInfo.role !== Constants.Roles.HR) {
        this.$router.go(-1);
        return false;
      }
      this.getWorkflows();
    },
    getWorkflows() {
      this.$store
        .dispatch(Actions.Workflow.Find, this.search)
        .then(() => {
          let len = this.workflows.length;
          if ((len < this.search.limit && len > 0) || len === 0) {
            this.pagination.disableNext = true;
          } else if (len === this.search.limit) {
            this.pagination.disableNext = false;
          }
        })
        .catch((e) => {
          console.error(Constants.Workflows.Messages.Error.Find, e);
          this.snackbarMessage = Constants.Workflows.Messages.Error.Find;
          this.snackbar = true;
        });
    },
    showWorkflow(id) {
      if (!id) return false;
      this.$router.push({
        name: Component.Protected.Company.Workflow.Edit,
        params: { id: id },
      });
    },
    createWF(tt) {
      if (!tt) return false;
      this.$store.dispatch(Actions.Workflow.Create, tt).catch((e) => {
        console.error(Constants.Workflows.Messages.Error.Add, e);
        this.snackbar = true;
        this.snackbarMessage = Constants.Workflows.Messages.Error.Add;
      });
    },
  },
  created() {
    if (this.userInfo && this.userInfo.role) {
      this.setup();
    } else {
      this.$store.dispatch(Actions.Firebase.UserInfo).then(() => this.setup());
    }
  },
};
</script>